import React, { useState } from "react";
import Image from "next/image";
import Modal from "./Modal";

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center justify-center py-8 md:py-16 lg:py-24 overflow-hidden dark:bg-jacarta-900">
      {/* Light mode gradient background */}
      <div
        className="absolute inset-0 dark:hidden"
        style={{
          background: `
            linear-gradient(
              120deg,
              rgba(226, 216, 227, 1) 0.9%,
              rgba(232, 235, 240, 1) 50.5%,
              rgba(222, 233, 239, 1) 100%
            ),
            linear-gradient(
              120deg,
              rgba(227, 120, 125, 1) 0%,
              rgba(103, 29, 172, 1) 20%,
              rgba(135, 210, 217, 1) 67.4%,
              rgba(133, 132, 195, 1) 100%
            )
          `,
        }}
      />

      <div className="container mx-auto px-5 relative z-[2] max-w-5xl">
        <div className="flex flex-col items-center justify-center text-center gap-8 md:gap-12">
          {/* Logo */}
          <div className="relative w-[137px] h-[137px] md:w-64 md:h-64">
            <Image
              src="/images/ico-logo/white.png"
              alt="Impactoverse Logo"
              fill
              className="object-contain"
              priority
              sizes="(max-width: 768px) 137px, (max-width: 1200px) 256px, 256px"
            />
          </div>

          {/* Text content container */}
          <div className="flex flex-col gap-8 md:gap-16 w-full">
            <div className="flex flex-col gap-8 md:gap-4">
              {/* Main heading */}
              <h1 className="font-bold text-2xl md:text-5xl lg:text-6xl text-[#374151] dark:text-[#EDEDED] text-center leading-[1.21] tracking-[0.021em]">
                Impactoverse Impact Art Marketplace
              </h1>

              {/* Description */}
              <p className="text-sm md:text-lg font-semibold max-w-4xl text-[#374151] dark:text-[#EDEDED] text-center leading-[1.57] tracking-[0.014em]">
                Launch an Impact Art campaign to raise funds. Improve your
                results by supercharging your campaigns with brand, creator, and
                influencer collabs.
              </p>

              {/* Tagline */}
              <p className="text-lg md:text-xl font-bold text-[#374151] dark:text-[#EDEDED] text-center leading-[1.22] tracking-[0.028em]">
                Impact Made <span className="text-accent">Fun</span> and{" "}
                <span className="text-accent">Easy</span>!
              </p>
            </div>

            {/* Button container */}
            <div className="flex justify-center">
              <button
                onClick={() => setIsModalOpen(true)}
                className="py-2 px-4 rounded-lg bg-accent text-[#EDEDED] shadow-lg font-bold text-sm border-2 border-accent transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-accent focus:ring-opacity-50 h-[42px] flex items-center justify-center gap-2.5"
                aria-label="Learn more about Impactoverse"
              >
                Learn More
              </button>
            </div>
          </div>

          {/* Modal */}
          <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </div>
      </div>
    </section>
  );
};

export default Hero;
